import { render, staticRenderFns } from "./ListItem3Template.vue?vue&type=template&id=cf38e4f2"
import script from "./ListItem3Template.vue?vue&type=script&lang=js"
export * from "./ListItem3Template.vue?vue&type=script&lang=js"
import style0 from "./ListItem3Template.vue?vue&type=style&index=0&id=cf38e4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports